/**
 * Created by mauget on 1/20/16.
 */

import contentTemplate          from 'designer/header-view.ejs';
import constants                from 'Constants.js';
import ContextBehaviorsMenuController    from 'ContextBehaviorsMenuController.js';
import BaseMainView             from 'BaseMainView.js';
import listService              from 'ListService.js';
import textConstants            from 'TextConstants';
import objectBehaviorMap        from 'ObjectBehaviorMapService.js';
import InstanceTabView          from 'behaviors/InstanceTabView.js';
import activeBehaviors          from 'behaviors/ActiveBehaviors.js';
import eventBus                 from 'EventBus.js';
import behaviorHelperService    from 'BehaviorHelperService.js';
import undoService              from 'UndoService.js'
import util                     from 'util/Util.js';
import leftPanelState           from "LeftPanelStateService";
import quickHelp from 'QuickHelpView';

const SILENT = constants.MODEL_SILENT;

//=============================================================================
//
// Behaviors view of PerfectForms Designer.
//
// -Lou Mauget, January 20, 2016
//
//=============================================================================
class BehaviorsView extends BaseMainView {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.events = {
        };

        //this.listenTo( eventBus, 'behaviorInstanceClose', this._closeBehaviorInstance );
        //this.listenTo( eventBus, 'behaviorInstanceShow', this._showBehaviorInstance );
        this.listenTo( eventBus, 'behaviorInstanceShow', this._showOpenInstances );

        return this;
    }

    //==========================================================
    // Impose well-known DOM IDs for use by Q/A test automation.
    // JQuery is our friend.
    //==========================================================
    injectTestIds() {

        const
            widgetSelector = '.factory-widget-icon',
            widgetPrefix = 'BHI_';
        super.injectTestIds(widgetSelector, widgetPrefix);

        const
            textSelector = '.factory-widget-text',
            textPrefix = 'BHT_';
        super.injectTestIds(textSelector, textPrefix);

    }


    initPage() {
        this._contextMenu = new ContextBehaviorsMenuController().menu;

        this.listenTo(this.model, 'change', this.render);

        this.initMenu( constants.KIND_BEHAVIORS );
        this.initBehaviorToolbarPane();
        $('#factories').addClass('disabledSection');

        this.initEditorContent( constants.KIND_BEHAVIORS );
        listService.currentBehaviorId = '';
        listService.currentSelectedPathId = undefined;

        if (this.instanceToLoad.behaviorKey) {

            var instance = listService.getBehaviorInstanceByObjectAndBehaviorKey(this.instanceToLoad.objectId, this.instanceToLoad.behaviorKey);
            if (instance) {

                listService._currentBehaviorInstanceId = instance.id;
                const info = behaviorHelperService.getBehaviorInfo(this.instanceToLoad.objectId, this.instanceToLoad.behaviorKey);
                instance.set('owner', info.owner, {silent:true});  // In case the Object Name changed since last displayed.
                instance.set('open', true, {silent:true});  // set to open
                behaviorHelperService.showBehaviorInstance(instance.id, 0,0, true);

            } else {
                // add
                const newInstance = behaviorHelperService.createNewInstanceOnLoad(this.instanceToLoad);
                eventBus.trigger('resizeBehaviorCanvas', constants.CANVAS_RAW_ID, newInstance.get('width'), newInstance.get('height'));
                $('#factories').removeClass('disabledSection');

                behaviorHelperService.showBehaviorInstance(listService._currentBehaviorInstanceId, 0,0, true);
                undoService.add({
                    undo: () => {
                        listService.destroyBehaviorInstance(newInstance.id);
                        if (listService.mainKind === constants.KIND_BEHAVIORS) {
                            $('#factories').addClass('disabledSection');
                        }
                    },
                    redo: () => {

                        listService.injectBehaviorInstance(newInstance);
                        eventBus.trigger('resizeBehaviorCanvas', constants.CANVAS_RAW_ID, newInstance.get('width'), newInstance.get('height'));
                        $('#factories').removeClass('disabledSection');

                        behaviorHelperService.showBehaviorInstance(listService._currentBehaviorInstanceId);
                    }
                }, textConstants.UNDO_NEW_BEHAVIOR);


            }
        } else {
            if (listService._currentBehaviorInstanceId) {
                behaviorHelperService.showBehaviorInstance(listService._currentBehaviorInstanceId, 0,0, true);
            } else {
                setTimeout( () => {
                    leftPanelState.restore();
                }, 250);
            }
        }
    }

    //=========================================================
    // PRIVATE
    //=========================================================
    _getBehaviorInfo(objectId, behaviorKey) {
        const returnObj = {
            text: '',
            owner: '',
            ownerId: objectId
        };

        if (behaviorKey === 'workflow') {
            returnObj.text = 'Workflow';
        } else {

            const obj = listService.getObject(objectId) || listService.getPage(objectId) || listService.currentForm;

            if (obj) {
                const type = obj.model.get('factoryKey');

                const found = objectBehaviorMap.getBehaviors(type).filter(behavior => (behavior.behaviorKey === behaviorKey));

                if (found.length) {
                    returnObj.text = found[0].text;
                }
                returnObj.owner = obj.model.get('name');

                if (type === 'layout_frame' || type === 'reports_frame') {
                    returnObj.owner = 'Form';
                    returnObj.ownerId = 'Form';
                }
            }
        }
        return returnObj;
    }

    //=========================================================
    // PRIVATE
    //=========================================================
    _showOpenTabs(openInstances) {

        openInstances.map( v => {
            const obj = new InstanceTabView( { model: v, el:constants.BEHAVIOR_TABS } );
            obj.render();
        });
    }

    //=========================================================
    // PRIVATE
    //=========================================================
    _closeBehaviorInstance(id ) {
        const thisInstance = listService.getBehaviorInstance(id);
        thisInstance.set('open', false);
        listService.updateBehaviorInstance(thisInstance.id, thisInstance);

        // set the CurrntInstanceID to 0
        listService._currentBehaviorInstanceId = 0;
    }


    //=========================================================
    // PRIVATE
    //=========================================================
    _showOpenInstances() {
        const openInstances = listService.getOpenBehaviorInstances();
        if (openInstances.size > 0) {
            // Populate the open indicators in the HTML
            this._showOpenTabs(openInstances);

            if ( !listService._currentBehaviorInstanceId ) {
                // get 1st instance and set the ID.
                const v = openInstances.first();
                if (v) {
                    listService._currentBehaviorInstanceId = v.id;
                }
            }

            // find the currentInstanceId and render it and all objects.
            openInstances
                .filter( v => v.id === listService._currentBehaviorInstanceId)
                .map( v => this._showBehaviorInstance(v.id) );

        } else {
            // no open instances, disable the Toolbox.
            $('#factories').addClass('disabledSection');

            // clear property panel
            $('#attributes-section').empty();
            $('#behaviors-section').empty();
            $('#property-tabs').empty();
        }

    }

    render() {
        this.$el.html(this.template(this.model.toJSON()));

        this.initPage();
        this.injectTestIds();

        const activeBeh = new activeBehaviors( { model: this.model, el:constants.ACTIVE_BEHAVIORS_CONTAINER } );
        activeBeh.render();

        util.printHeader(listService.dashboardLayout.mainPanelView.model);

        this.delegateEvents();
        util.enableSaveOption();
        
        const behaviorProp =  listService.getBehaviorInstance(listService.currentBehaviorInstanceId);
        if(behaviorProp){                
            const oNameBehavior = behaviorProp.get('name') || behaviorProp.get('text');
            $('.rail-header-text').text(oNameBehavior + constants.RIGHT_PANEL_PROPERTIES_TITLE);
            $('.rail-header-text').prop('title', oNameBehavior + constants.RIGHT_PANEL_PROPERTIES_TITLE);
        }
        eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, 'BEHAVIOR', listService.currentBehaviorInstanceId);
        
        const quickHelpView = new quickHelp({el:".quick-help-view", type: 'app', helpLink: ""});
        quickHelpView.render();

        return this;
    }
    
    removeUnused() {
        this._contextMenu.destroy();
    }
    
    remove() {
        this._contextMenu.destroy();
        super.remove();
    }
}

export default BehaviorsView;
